import React, { useEffect, useState } from "react";
import { authService } from "../services/auth";

interface AuthErrorHandlerProps {
  children: React.ReactNode;
}

const AuthErrorHandler: React.FC<AuthErrorHandlerProps> = ({ children }) => {
  useEffect(() => {
    const handleAuthFailure = async () => {
      try {
        // Clear local auth state without calling logout API
        // This prevents the 401 logout loop
        authService.clearAuthState();
        // Redirect to login page
        window.location.href = "/login";
      } catch (error) {
        console.error("Auth failure handling error:", error);
        // Fallback: force redirect to login
        window.location.href = "/login";
      }
    };

    window.addEventListener("auth-failed", handleAuthFailure);

    return () => {
      window.removeEventListener("auth-failed", handleAuthFailure);
    };
  }, []);

  return <>{children}</>;
};

export default AuthErrorHandler;
